import endpoints from "config/endpoints";
import { valuePerTitle } from "constants/sorteios";
import { useAppContext } from "contexts/AppContext";
import { useCallback } from "react";
import { formatarDataServidor } from "utils/date";
import { getEnvVar } from "utils/environment";
import useAxiosRequest from "./common/useAxiosRequest";

const useCotacao = () => {
  const { titleAmount, produto, versao } = useAppContext();
  const { data, loading, error, run } = useAxiosRequest();

  const salvarCotacao = useCallback(
    ({ dadosPessoais, dadosProfissionais, dadosContato, dadosEndereco }) => {
      const payload = {
        estruturaComercial: [
          {
            empresa: {
              CNPJ: getEnvVar("CNPJ"),
              nome: "CAIXA SEGURADORA S.A.",
            },
          },
        ],
        clientes: [
          {
            tipoCliente: {
              codigo: "TITUL",
              descricao: "Titular",
            },
            pessoa: {
              identificacao: {
                tipo: "F",
                documento: "CPF",
                codigo: dadosPessoais?.cpf,
              },
              nome: dadosPessoais?.nome,
              nomeSocial: dadosPessoais?.nomeSocial || '',
              dadosPessoaFisica: {
                dataNascimento: formatarDataServidor(
                  dadosPessoais?.dataNascimento
                ),
                sexo: {
                  codigo: dadosPessoais?.sexo,
                },
                profissao: {
                  codigo: `${dadosProfissionais?.profissao?.id}`,
                  valor: `${dadosProfissionais?.profissao?.value}`,
                },
              },
              informacoesEconomicas: {
                faixaRenda: [
                  {
                    codigo: dadosProfissionais?.renda?.id,
                    descricao: dadosProfissionais?.renda?.value,
                    tipoRenda: "individual",
                  },
                ],
              },
              endereco: {
                cep: dadosEndereco?.cep,
                estado: dadosEndereco?.dadosComplementares?.uf?.id,
                cidade: dadosEndereco?.dadosComplementares?.cidade,
                bairro: dadosEndereco?.dadosComplementares?.bairro,
                logradouro: dadosEndereco?.dadosComplementares?.endereco,
                numero: dadosEndereco?.dadosComplementares?.numero,
                complemento: dadosEndereco?.dadosComplementares?.complemento,
              },
              comunicacao: {
                parametros: [
                  {
                    codigo: "email",
                    tipo: "PES",
                    valor: dadosContato?.email,
                  },
                  {
                    codigo: "telefone",
                    tipo: "CEL",
                    valor: dadosContato?.celular,
                  },
                ],
                recebimento: [
                  {
                    celular: dadosContato?.receberNovidades === "S",
                    email: dadosContato?.receberNovidades === "S",
                  },
                ],
              },
            },
          },
        ],
        itemCapitalizacao: {
          titulos: [
            {
              planosTitulos: {
                titulo: `${titleAmount}`,
                valor: `${valuePerTitle}`,
              },
            },
          ],
        },
        oferta: {
          identificacao: {
            codigoOferta: versao,
            codigoProduto: produto,
          },
        },
      };

      if (dadosContato?.telefone) {
        payload.clientes[0].pessoa.comunicacao.parametros.push({
          codigo: "telefone",
          tipo: "RES",
          valor: dadosContato?.telefone,
        });
      }

      return run({
        url: endpoints.cotacao(),
        method: "POST",
        data: payload,
      });
    },
    [produto, run, titleAmount, versao]
  );

  return { salvarCotacao, data, loading, error };
};

export default useCotacao;
